<template>
  <div class="subscription-settings">
    
    <div class="settings-wrapper">
      <!-- Membership Card Tab -->
      <div v-if="activeTab === 'membership_card'">
        <membership-card-template-builder 
          ref="membershipCardBuilder"
          :template_id="membershipCardTemplateId" 
          :template="membershipCardTemplate"
          @templateSaved="onMembershipCardTemplateSaved"
          @templateDeleted="onMembershipCardTemplateDeleted"
        />
      </div>

      <!-- General Settings Tab -->
      <div v-if="activeTab === 'general'">
        <h6 class="mb-3">{{ $t('subscription_settings') }}</h6>
        <p class="text-muted mb-4 small">{{ $t('subscription_settings_description') }}</p>
        
        <div class="alert alert-info">
          <AppIcon name="bi-info-circle" class="bi bi-info-circle me-2" />
          {{ $t('additional_subscription_settings_coming_soon') }}
        </div>
        
        <!-- Placeholder for future subscription settings -->
        <div class="card">
          <div class="card-body">
            <h6 class="mb-3">{{ $t('subscription_defaults') }}</h6>
            <p class="text-muted small">{{ $t('subscription_defaults_description') }}</p>
            
            <!-- Future settings will go here -->
            <div class="text-muted text-center py-4">
              <AppIcon name="bi-wrench-adjustable" class="bi bi-wrench-adjustable" style="font-size: 3rem; opacity: 0.3;" />
              <p class="mt-2">{{ $t('more_settings_coming_soon') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MembershipCardTemplateBuilder from './MembershipCardTemplateBuilder.vue';
import helper from '../../helper';

export default {
  name: 'SubscriptionSettings',
  components: {
    MembershipCardTemplateBuilder
  },
  props: ['activeTab'],
  data() {
    return {
      membershipCardTemplateId: null,
      membershipCardTemplate: null
    };
  },
  methods: {
    async loadMembershipCardTemplate() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/templates?type=membership_card`);
        if (response.data && response.data.templates && response.data.templates.length > 0) {
          const template = response.data.templates[0];
          this.membershipCardTemplateId = template.id;
          
          if (template.data) {
            try {
              this.membershipCardTemplate = typeof template.data === 'string' 
                ? JSON.parse(template.data) 
                : template.data;
            } catch (error) {
              alert('Error parsing membership card template: ' + error.message);
              this.membershipCardTemplate = null;
            }
          }
        }
      } catch (error) {
        alert('Error loading membership card template: ' + error.message);
      }
    },
    async onMembershipCardTemplateSaved() {
      await this.loadMembershipCardTemplate();
      this.$emit('templateSaved');
    },
    async onMembershipCardTemplateDeleted() {
      this.membershipCardTemplateId = null;
      this.membershipCardTemplate = null;
      this.$emit('templateDeleted');
    }
  },
  mounted() {
    this.loadMembershipCardTemplate();
  }
};
</script>

<style scoped>
.subscription-settings {
  padding: 0;
}

.nav-pills .nav-link {
  border-radius: 8px;
  color: #6c757d;
  font-weight: 500;
  padding: 0.5rem 1rem;
  transition: all 0.2s;
}

.nav-pills .nav-link:hover {
  background-color: #f8f9fa;
  color: #303030;
}

.nav-pills .nav-link.active {
  background-color: #303030;
  color: white;
}

.tab-content {
  animation: fadeIn 0.3s;
  max-height: calc(80vh - 180px);
  overflow-y: auto;
  overflow-x: hidden;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
